export const getPaddingBasedOnAsset = (
  isVideoStage: boolean = false,
  defaultPadding: string = '0',
  shouldUseDefault: boolean = false,
) => {
  if (shouldUseDefault) return defaultPadding;
  return isVideoStage ? 'var(--spacing-relative-8xl)' : defaultPadding;
};
